import { SelectOption } from '../ListTableTypes';

export const checkIfSomeFilteredOptionNotSelected = (
    selectedOptions: SelectOption[],
    filteredOptions: SelectOption[]
): boolean =>
    filteredOptions.some(
        (filteredOption) => !selectedOptions.find((selectedOption) => selectedOption.value === filteredOption.value)
    );

export const checkIfSomeFilteredOptionSelected = (
    selectedOptions: SelectOption[],
    filteredOptions: SelectOption[]
): boolean =>
    filteredOptions.some((filteredOption) =>
        selectedOptions.find((selectedOption) => selectedOption.value === filteredOption.value)
    );

export const mergeOptions = (selectedOptions: SelectOption[], optionsToBeAdd: SelectOption[]) => {
    const result = [...selectedOptions];
    optionsToBeAdd.forEach((optionToBeAdd) => {
        const index = result.findIndex((selectedOption) => selectedOption.value === optionToBeAdd.value);
        if (index === -1) {
            result.push(optionToBeAdd);
        }
    });
    return result;
};

export const separateOptions = (selectedOptions: SelectOption[], optionsToBeRemoved: SelectOption[]) =>
    selectedOptions.filter(
        (selectedOption) =>
            !optionsToBeRemoved.some((optionToBeRemoved) => selectedOption.value === optionToBeRemoved.value)
    );
